/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import type { OrganizationTheme } from "../../types";

export const neutralGoldTheme: OrganizationTheme = {
  id: "neutral-gold",
  name: "Neutral Gold",
  description:
    "Modern, premium aesthetic with true neutral grays and bold gold accents",
  recommendedFor: [
    "General Contracting",
    "Commercial Construction",
    "All Trades",
  ],
  isDefault: true,

  colors: {
    primary: {
      name: "Near Black",
      hex: "#1F1F1F",
      hsl: "0 0% 12%",
      rgb: [31, 31, 31],
    },
    primaryForeground: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    secondary: {
      name: "Tuscan Sun",
      hex: "#F5CB5C",
      hsl: "44 89% 66%",
      rgb: [245, 203, 92],
    },
    secondaryForeground: {
      name: "Near Black",
      hex: "#1F1F1F",
      hsl: "0 0% 12%",
      rgb: [31, 31, 31],
    },
    muted: {
      name: "Warm Gray",
      hex: "#F6F5F3",
      hsl: "40 4% 96%",
      rgb: [246, 245, 243],
    },
    mutedForeground: {
      name: "Medium Gray",
      hex: "#666666",
      hsl: "0 0% 40%",
      rgb: [102, 102, 102],
    },
    card: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    cardForeground: {
      name: "Near Black",
      hex: "#1F1F1F",
      hsl: "0 0% 12%",
      rgb: [31, 31, 31],
    },
    background: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    foreground: {
      name: "Near Black",
      hex: "#1F1F1F",
      hsl: "0 0% 12%",
      rgb: [31, 31, 31],
    },
  },

  cssVariables: {
    "--primary": "0 0% 12%",
    "--primary-foreground": "0 0% 100%",
    "--secondary": "44 89% 66%",
    "--secondary-foreground": "0 0% 12%",
    "--muted": "40 4% 96%",
    "--muted-foreground": "0 0% 40%",
    "--card": "0 0% 100%",
    "--card-foreground": "0 0% 12%",
    "--background": "0 0% 100%",
    "--foreground": "0 0% 12%",
    // Semantic colors — clean, universal against neutral base
    "--success": "142 71% 45%",
    "--success-foreground": "0 0% 98%",
    "--warning": "38 92% 50%",
    "--warning-foreground": "0 0% 12%",
    "--error": "0 84% 51%",
    "--error-foreground": "0 0% 98%",
    "--info": "221 83% 53%",
    "--info-foreground": "0 0% 98%",
    "--destructive": "0 84% 51%",
    "--destructive-foreground": "0 0% 98%",
    // Sidebar / warm surface — subtle tint of secondary hue
    "--background-warm": "44 20% 98%",
    "--background-warm-alt": "44 15% 96%",
    // Extended palette — vibrant, high-contrast accents against neutral base
    "--palette-violet": "258 65% 58%",
    "--palette-teal": "178 55% 40%",
    "--palette-pink": "338 65% 52%",
    "--palette-orange": "24 85% 52%",
    "--palette-sky": "200 75% 48%",
  },
};
